// src/constants/unitTypes.js

export const unitTypeLabels = {
    sejour_vacances: 'Séjour de vacances',
    sejour_court: 'Séjour court',
    sejour_specifique: 'Séjour spécifique',
    sejour_famille: 'Séjour en famille',
    accueil_loisirs: 'Accueil de loisirs',
    accueil_jeunes: 'Accueil de jeunes',
    scoutisme: 'Scoutisme',
    '': 'Non spécifié' // Pour les cas où le type pourrait être vide ou non défini
};

export const getUnitTypeLabel = (typeValue) => {
    return unitTypeLabels[typeValue] || typeValue; // Retourne le label ou la valeur brute si non trouvée
};